var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDineSaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "25px",
    viewBox: "0 0 34 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color/32-content/box-2@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 33.6,
    height: 33.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning",
    transform: "translate(-309.000000, -4793.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/32-content/box-2",
    transform: "translate(309.000000, 4784.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,23.8 L30.1000001,23.8 C30.4864001,23.8 30.8000001,23.4864 30.8000001,23.1 C30.8000001,22.715 30.4864001,22.4 30.1000001,22.4 L3.49999994,22.4 C3.11359994,22.4 2.79999994,22.715 2.79999994,23.1 C2.79999994,23.4864 3.11359994,23.8 3.49999994,23.8 Z",
    id: "Path-Copy",
    fill: "#E7E9E9",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,21 L30.1000001,21 C30.4864001,21 30.8000001,20.6864 30.8000001,20.3 C30.8000001,19.915 30.4864001,19.6 30.1000001,19.6 L3.49999994,19.6 C3.11359994,19.6 2.79999994,19.915 2.79999994,20.3 C2.79999994,20.6864 3.11359994,21 3.49999994,21 Z",
    id: "Path-Copy-3",
    fill: "#E7E9E9",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,22.4 L30.1000001,22.4 C30.4864001,22.4 30.8000001,22.0864 30.8000001,21.7 C30.8000001,21.315 30.4864001,21 30.1000001,21 L3.49999994,21 C3.11359994,21 2.79999994,21.315 2.79999994,21.7 C2.79999994,22.0864 3.11359994,22.4 3.49999994,22.4 Z",
    id: "Path-Copy-2",
    fill: "#C6C2BF",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,19.6 L30.1000001,19.6 C30.4864001,19.6 30.8000001,19.2864 30.8000001,18.9 C30.8000001,18.515 30.4864001,18.2 30.1000001,18.2 L3.49999994,18.2 C3.11359994,18.2 2.79999994,18.515 2.79999994,18.9 C2.79999994,19.2864 3.11359994,19.6 3.49999994,19.6 Z",
    id: "Path-Copy-4",
    fill: "#C6C2BF",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,18.2 L30.1000001,18.2 C30.4864001,18.2 30.8000001,17.8864 30.8000001,17.5 C30.8000001,17.115 30.4864001,16.8 30.1000001,16.8 L3.49999994,16.8 C3.11359994,16.8 2.79999994,17.115 2.79999994,17.5 C2.79999994,17.8864 3.11359994,18.2 3.49999994,18.2 Z",
    id: "Path-Copy-6",
    fill: "#E7E9E9",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,16.8 L30.1000001,16.8 C30.4864001,16.8 30.8000001,16.4864 30.8000001,16.1 C30.8000001,15.715 30.4864001,15.4 30.1000001,15.4 L3.49999994,15.4 C3.11359994,15.4 2.79999994,15.715 2.79999994,16.1 C2.79999994,16.4864 3.11359994,16.8 3.49999994,16.8 Z",
    id: "Path-Copy-5",
    fill: "#C6C2BF",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,15.4 L30.1000001,15.4 C30.4864001,15.4 30.8000001,15.0864 30.8000001,14.7 C30.8000001,14.315 30.4864001,14 30.1000001,14 L3.49999994,14 C3.11359994,14 2.79999994,14.315 2.79999994,14.7 C2.79999994,15.0864 3.11359994,15.4 3.49999994,15.4 Z",
    id: "Path-Copy-8",
    fill: "#E7E9E9",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,14 L30.1000001,14 C30.4864001,14 30.8000001,13.6864 30.8000001,13.3 C30.8000001,12.915 30.4864001,12.6 30.1000001,12.6 L3.49999994,12.6 C3.11359994,12.6 2.79999994,12.915 2.79999994,13.3 C2.79999994,13.6864 3.11359994,14 3.49999994,14 Z",
    id: "Path-Copy-7",
    fill: "#C6C2BF",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,12.6 L30.1000001,12.6 C30.4864001,12.6 30.8000001,12.2864 30.8000001,11.9 C30.8000001,11.515 30.4864001,11.2 30.1000001,11.2 L3.49999994,11.2 C3.11359994,11.2 2.79999994,11.515 2.79999994,11.9 C2.79999994,12.2864 3.11359994,12.6 3.49999994,12.6 Z",
    id: "Path-Copy-10",
    fill: "#E7E9E9",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49999994,11.2 L30.1000001,11.2 C30.4864001,11.2 30.8000001,10.8864 30.8000001,10.5 C30.8000001,10.115 30.4864001,9.8 30.1000001,9.8 L3.49999994,9.8 C3.11359994,9.8 2.79999994,10.115 2.79999994,10.5 C2.79999994,10.8864 3.11359994,11.2 3.49999994,11.2 Z",
    id: "Path-Copy-9",
    fill: "#C6C2BF",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9000001,21 L23.1,21 C22.7136,21 22.4,21.315 22.4,21.7 L22.4,23.8 L11.2,23.8 L11.2,21.7 C11.2,21.315 10.8864,21 10.4999999,21 L0.699999933,21 C0.313599931,21 -7.00000058e-08,21.315 -7.00000058e-08,21.7 L-7.00000058e-08,32.9000001 C-7.00000058e-08,33.2864001 0.313599931,33.6000001 0.699999933,33.6000001 L32.9000001,33.6000001 C33.2864001,33.6000001 33.6000001,33.2864001 33.6000001,32.9000001 L33.6000001,21.7 C33.6000001,21.315 33.2864001,21 32.9000001,21 Z",
    id: "Fill/box-2",
    fill: "#669DB4",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineSaker);
export default __webpack_public_path__ + "static/media/DineSaker.26022f649c0050a9e981b957869511b6.svg";
export { ForwardRef as ReactComponent };